import React, { useState, useEffect} from 'react'
import styles from './Inventory.module.css'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import moment from 'moment'
import { useHistory } from 'react-router-dom'
import { toCommas } from '../../utils/utils'
import { useSnackbar } from 'react-simple-snackbar'

import IconButton from '@material-ui/core/IconButton';
import DeleteOutlineRoundedIcon from '@material-ui/icons/DeleteOutlineRounded';
import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider, KeyboardDatePicker } from '@material-ui/pickers';
import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import InputBase from '@material-ui/core/InputBase';
import { Container, Grid, Snackbar } from '@material-ui/core';
import Avatar from '@material-ui/core/Avatar';
import Divider from '@material-ui/core/Divider';
import SaveIcon from '@material-ui/icons/Save';
import Button from '@material-ui/core/Button';
import Chip from '@material-ui/core/Chip';
import {initialStateInventory} from '../../initialState'
import { createInventory, getInventory, updateInventory } from '../../actions/inventoryAction';
import { getVendorsByUser } from '../../actions/vendorActions'
import AddVendor from '../Vendors/AddVendor';
import InventoryType from './InventoryType';
import axios from 'axios'
import { useLocation } from 'react-router-dom'
import { getMetalsByUser } from '../../actions/metalActions'

const useStyles = makeStyles((theme) => ({
    root: {
      display: 'flex',
      '& > *': {
        margin: theme.spacing(1),
      },
    },
    large: {
      width: theme.spacing(12),
      height: theme.spacing(12),
    },
    table: {
        minWidth: 650,
      },

    headerContainer: {
        // display: 'flex'
        paddingTop: theme.spacing(1),
        paddingLeft: theme.spacing(5),
        paddingRight: theme.spacing(1),
    }
  }));

const Inventory = () => {

    const location = useLocation()
    const [inventoryData, setInventoryData] = useState(initialStateInventory)
    const [currency, setCurrency] = useState("USD")
    const [subTotal, setSubTotal] = useState(0)
    const [stockPrice, setStockPrice] = useState(0)
    const [total, setTotal] = useState(0)
    const today = new Date();
    const [selectedDate, setSelectedDate] = useState(moment().format('MM/DD/YYYY'));
    const [vendor, setVendor] = useState(null)
    const [vendorId, setVendorId] = useState(0)
    const [metal, setMetal] = useState(null)
    const [type, setType] = useState('Inventory')
    const { id } = useParams()   
    const [openSnackbar, closeSnackbar] = useSnackbar()
    
    const vendors = useSelector((state) => state.vendors.vendors)
    const metals = useSelector((state) => state.metals.metals)
    const { inventory } = useSelector((state) => state.inventories);
    const dispatch = useDispatch()
    const history = useHistory()
    const user = JSON.parse(localStorage.getItem('profile'))

    const handleChange =(index, e) => {
        const values = [...inventoryData.items]
        values[index][e.target.name] = e.target.value
        setInventoryData({...inventoryData, items: values})
        calculateAmount(stockPrice);
        
    }
      

    const getInventoryNumber = async() => {
      try {
      
        const response = await axios.get(`${global.config.API_URL}/inventory/nextInventoryNumber`);
          setInventoryData({...inventoryData, inventoryNumber: (Number(response.data.count) + 1).toString().padStart(3, '0')})
         } catch (error) {
        console.error(error);
      }
    }

    useEffect(() => {
       if (id !==undefined){
        dispatch(getInventory(id));
        setInventoryData({...inventoryData, inventoryNumber: inventory.inventoryNumber});
        setVendor(inventory.vendor[0]);           
        setStockPrice(inventory.stockPrice);
        setSelectedDate(inventory.invoiceDate);
       }
        else
        { getInventoryNumber();
        }
        // eslint-disable-next-line
      }, [id]);


           
    useEffect(() => {
        dispatch(getMetalsByUser({search: ''}));
        dispatch(getVendorsByUser({search: ''}));
        // eslint-disable-next-line
       }, [dispatch]);




    useEffect(() => {
        if(inventory) {
            //Automatically set the default inventory values as the ones in the inventory to be updated
            setInventoryData(inventory)
            setVendor(inventory.vendor[0])
            setSelectedDate(inventory.inventoryDate)
            setStockPrice(inventory.stockPrice)
        }
    }, [inventory])

 
    
    const vendorsProps = {       
        options: vendors,
        getOptionLabel: (option) => option.name? option.name:''
      };
    
   const metalsProps = {
        options: metals,
        getOptionLabel: (option) => option.metalName?option.metalName :''
      };
      
    
    const handleDateChange = (date) => {
      setSelectedDate(date);
    };

    const calculateAmount = (price) =>{

   
        const tmpitems = [...inventoryData.items];
        tmpitems.forEach((item)=>{

            if(stockPrice>0 && !isNaN(item.metal?.metalName)){
                //stock Price  X 1.01 / 31.1 X (purity) + labor becomes unit price                
                var purity = '0.'+item.metal?.metalName.trim();
                item.unitPrice = ((parseFloat(((price*1.01) / (31.1 * parseFloat(purity)))) + parseFloat(item.labor))).toFixed(2);
                item.amount = parseFloat(item.weight) * parseFloat(item.unitPrice).toFixed(2);
               }   

        });

        setInventoryData({...inventoryData, items: tmpitems});  
        //console.log(JSON.stringify(invoiceData));      
    }

       useEffect(() => {
               //Get the subtotal
               const subTotal =()=> {
               var arr = document.getElementsByName("amount");
               var subtotal = 0;
               for(var i = 0; i < arr.length; i++) {
                   if(arr[i].value) {
                       subtotal += +arr[i].value;
                   }
                   setSubTotal(subtotal)
                   setTotal(subtotal)
               }
           }
   
           subTotal()
          
       }, [inventoryData])

       

    const handleAddField = (e) => {
        e.preventDefault()
        setInventoryData((prevState) => ({...prevState, items: [...prevState.items,  { metal:{id:0,metalName:''} ,  weight: 0 }]}))
    }

    const handleRemoveField =(index) => {
        const values = inventoryData.items
        values.splice(index, 1)
        setInventoryData((prevState) => ({...prevState, values}))
    }
    


    const handleSubmit =  async (e ) => {
        e.preventDefault()
        if (vendor==null){
            alert("select vendor")
            return
        }

    
        const items = [...inventoryData.items]
        const saveItems=[];

        if (items.length===0){
            alert("enter item info")
            return
        }

        items.forEach((item)=>{
        
           saveItems.push({metalId:item.metal.id, 
            weight:parseFloat(item.weight),
            description: item.description,
            labor:parseFloat(item.labor),
            stockPrice: stockPrice,
            unitPrice:parseFloat(item.unitPrice),
            amount:parseFloat(item.amount) })     
        });

        //inventoryData = {...inventoryData, items: saveItems}
        let saveFormData = {};
        if (id===undefined)
           saveFormData= {
                inventoryNumber: inventoryData.inventoryNumber,
                inventoryDate: selectedDate, 
                vendorId,
                createdBy:user?.result?.id,
                stockPrice:stockPrice,                
                items: saveItems, 
            }
        else
            saveFormData= {
            id:id,
            inventoryNumber: inventoryData.inventoryNumber,
            inventoryDate: selectedDate, 
            vendorId,
            modifiedBy:user?.result?.id,
            stockPrice:stockPrice,
            items: saveItems, 
            }


        
        if(inventory) {

         dispatch(updateInventory(id,saveFormData, history,openSnackbar)) 
         history.push(`/inventories`)
        } else {

        dispatch(createInventory(saveFormData,history,openSnackbar))
        history.push(`/inventories`)
        }

        // setInventoryData(initialState)
    }

    const classes = useStyles()
    const [openVendor, setOpenVendor] = useState(false);

    const CustomPaper = (props) => {
        return <Paper elevation={3} {...props} />;
      };


      if(!user) {
        history.push('/login')
      }
    

    return (
    <div className={styles.inventoryLayout}>
        <form onSubmit={handleSubmit} className="mu-form">
            <AddVendor setOpenVendor={setOpenVendor} openVendor={openVendor} />
            <Container  className={classes.headerContainer}>
                
                <Grid container justifyContent="space-between" >
                    <Grid item>
                        {/* <Avatar alt="Logo" variant='square' src="" className={classes.large} /> */}
                    </Grid>
                    <Grid item>
                        <InventoryType type={type} setType={setType} />
                        Inventory #:
                        <div style={{
                            marginTop: '15px',
                            width: '100px',
                            padding: '8px',
                            display: 'inline-block',
                            backgroundColor: '#f4f4f4',
                            outline: '0px solid transparent'
                        }} 
                            contenteditable="true"
                            onInput={e => setInventoryData({
                            ...inventoryData, inventoryNumber: e.currentTarget.textContent})
                            }
                        >
                        <span style={{width:'40px',
                            color: 'black',
                            padding: '15px',
                        }} 
                            contenteditable="false"> {inventoryData.inventoryNumber}</span>
                        <br/>
                        </div>
                    </Grid>
                </Grid >
            </Container>
            <Divider />
            <Container>
                <Grid container justifyContent="space-between" style={{marginTop: '40px'}} >
                    <Grid item style={{width: '50%'}}>
                        <Container>
                            <Typography variant="overline" style={{color: 'gray', paddingRight: '3px'}} gutterBottom>Buy from</Typography>
                            

                            {vendor  && (
                                <>
                                    <Typography variant="subtitle2" gutterBottom>{vendor.name}</Typography>
                                    <Typography variant="body2" >{vendor.email}</Typography>
                                    <Typography variant="body2" >{vendor.phone}</Typography>
                                    <Typography variant="body2">{vendor.address}</Typography>
                                    <Button color="primary" size="small" style={{textTransform: 'none'}} onClick={()=> setVendor(null)}>Change</Button>
                                </>
                            )}
                            
                            <div style={vendor? {display: 'none'} :  {display: 'block'}}>
                                <Autocomplete
                                            {...vendorsProps}                                            
                                            PaperComponent={CustomPaper}
                                                renderInput={(params) => <TextField {...params}
                                                required={!inventory && true} 
                                                label="Select Vendor" 
                                                margin="normal" 
                                                variant="outlined"
                                                name="vendor"
                                                />}
                                            value={vendors?.name}
                                            onChange={(event, value) => {setVendor(value)
                                                setVendorId(value.id)}
                                            }
                                            
                                    />

                            </div>
                            {!vendor && 
                                <>
                                <Grid item style={{paddingBottom: '10px'}}>
                                    <Chip
                                        avatar={<Avatar>+</Avatar>}
                                        label="New Vendor"
                                        onClick={() => setOpenVendor(true)}
                                        variant="outlined"
                                    />
                                </Grid>
                                </>
                            }
                        </Container>
                    </Grid>

                    <Grid item style={{marginRight: 20, textAlign: 'right'}}>
                         <Typography variant="overline" style={{color: 'gray'}} gutterBottom>Date</Typography>
                        <Typography variant="body2" gutterBottom>{moment(selectedDate).format("MMM Do YYYY")}</Typography>
                        <Typography variant="overline" gutterBottom>Stock Price</Typography>
                        <Typography variant="h6" gutterBottom align="right">{currency}  <TextField  inputProps={{min: 0, style: { textAlign: 'right',width:"70px" }}}  size="small"  type="number" name="stockPrice"  onChange={e => {setStockPrice(parseFloat(e.target.value)); calculateAmount(parseFloat(e.target.value));}} value={stockPrice} placeholder="0" /></Typography>
                    </Grid>
                </Grid>
            </Container>

        
    <div>

        <TableContainer component={Paper} className="tb-container">
        <Table className={classes.table} aria-label="simple table">
            <TableHead>
            <TableRow>
                <TableCell>Item</TableCell>
                  <TableCell align="right">Weight</TableCell>
                  <TableCell align="left">Desc</TableCell>                
                  <TableCell align="right">Labor</TableCell>
                  <TableCell align="right">Price</TableCell>
                  <TableCell align="right">Amount</TableCell>
                  <TableCell >Action</TableCell>
            </TableRow>
            </TableHead>
            <TableBody>
            {inventoryData.items.map((itemField, index) => (
                <TableRow key={index}>
                <TableCell  scope="row" style={{width: '30%' }}> 
                  <Autocomplete
                                            {...metalsProps}
                                            PaperComponent={CustomPaper}
                                            style={{width: '90%'}}
                                            sx={{ ml: 1, flex: 1 }}
                                                renderInput={(params) => <TextField {...params}
                                                required={!inventory && true} 
                                                label="Select metal name" 
                                                margin="normal" 
                                                variant="outlined"
                                                name="metalId"
                                                />}
                                            value={itemField.metal}
                                            onChange={(event, value) => {
                                                if(value!=null){
                                                const values = [...inventoryData.items]
                                                values[index]['metal'] = value;
                                                setInventoryData({...inventoryData, items: values})
                                                //alert(JSON.stringify(inventoryData))
                                                }
                                              
                                            }}
                                            
                   />
                
                </TableCell>
            
                <TableCell align="right"> <InputBase inputProps={{ style: { textAlign: 'right',width:"70px" }}} sx={{ ml: 1, flex: 1 }} type="number" name="weight" onChange={e => {handleChange(index, e);}} value={itemField.weight} placeholder="0" /> </TableCell>
                <TableCell alight="left"> <InputBase style={{textAlign:"left"}}  sx={{ ml: 1, flex: 1 }} multiline="true" type="text" name="description" onChange={e => handleChange(index, e)} value={itemField.description} placeholder="description" /> </TableCell>
                <TableCell align="right"> <InputBase inputProps={{min: 0, style: { textAlign: 'right',width:"70px" }}} sx={{ ml: 1, flex: 1 }} type="number" name="labor"  onChange={e => handleChange(index, e)} value={itemField.labor} placeholder="0" /> </TableCell>
                <TableCell align="right"> <InputBase inputProps={{ style: { textAlign: 'right',width:"70px" }}} sx={{ ml: 1, flex: 1 }} type="number" name="unitPrice"  value={itemField.unitPrice} placeholder="0" disabled/> </TableCell>
                 <TableCell align="right"> <InputBase inputProps={{style: { textAlign: 'right',width:"70px" }}} sx={{ ml: 1, flex: 1 }} type="number" name="amount"   value={itemField.amount?.toFixed(2)} disabled placeholder="0" /> </TableCell>
                
                <TableCell align="right"> 
                    <IconButton onClick={() =>handleRemoveField(index)}>
                        <DeleteOutlineRoundedIcon style={{width: '20px', height: '20px'}}/>
                    </IconButton>
                </TableCell>
                
                </TableRow>
            ))}
            </TableBody>
        </Table>
        </TableContainer>
            <div className={styles.addButton}>
                <button onClick={handleAddField}>+</button>
            </div>
         </div>
             <div className={styles.invoiceSummary} style={{float:'right', marginTop: '20px',marginBottom: '20px', padding: '10px',width:'50%', border: '1px solid #e0e0e0', borderRadius: '5px'}}>
                        <div className={styles.summary}>Inventory Summary</div>
                        <div className={styles.summaryItem}>
                            <p>Sub total:</p>
                            <h4>{toCommas(subTotal.toFixed(2))}</h4>
                        </div>
                     
                        <div className={styles.summaryItem}>
                            <p>Total</p>
                            <h4 style={{color: "black", fontSize: "18px", lineHeight: "8px"}}>{currency} {toCommas(total.toFixed(2))}</h4>
                        </div>
                        
          </div>
    
                    
      

        
        
         

            {/* <button className={styles.submitButton} type="submit">Save and continue</button> */}
            <Grid container justifyContent="center">
            <Button
                variant="contained"
                style={{justifyContentContent: 'center'}}
                type="submit"
                color="primary"
                size="large"
                className={classes.button}
                startIcon={<SaveIcon />}
            >
                Save
            </Button>
            </Grid>
        </form>
    </div>
    )
}

export default Inventory
